export default "<template>\n\n  <KButton\n    disabled\n    text=\"Secondary Button\"\n    appearance=\"flat-button\"\n  />\n\n</template>\n";